<script module>
	export { QuickStatSeparator };
</script>

<script lang="ts">
	import NativeText from '$lib/components/ui/NativeText.svelte';

	const {
		label,
		value,
		valueFirst = true,
		valueNativeLanguage,
		title
	}: {
		label?: string;
		value: string | number;
		valueFirst?: boolean;
		valueNativeLanguage?: { languageCode: string; isLanguageRTL: boolean };
		title?: string;
	} = $props();
</script>

<div {title}>
	{#if valueFirst}
		{@render Value(value)}
		{#if label}
			{@render Label(label)}
		{/if}
	{:else}
		{#if label}
			{@render Label(label)}
		{/if}
		{@render Value(value)}
	{/if}
</div>

{#snippet Value(value: string | number)}
	<span class="font-mono text-sm font-black tracking-wide text-white">
		{#if valueNativeLanguage}
			<NativeText
				languageCode={valueNativeLanguage.languageCode}
				isLanguageRTL={valueNativeLanguage.isLanguageRTL}
				text={`${value}`}
			/>
		{:else}
			{value}
		{/if}
	</span>
{/snippet}

{#snippet Label(label: string)}
	<span class="font-mono text-sm font-semibold tracking-wide">{label}</span>
{/snippet}

{#snippet QuickStatSeparator()}
	<span class="text-white/15 first:hidden">•</span>
{/snippet}
